import React, { useState, useEffect } from 'react';
import { getGalleryImages } from '../../services/getAllApi';
import '../../styles/CampusLife.css';

const CampusLife = () => {
    const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const imageCount = 25;

    useEffect(() => {
        // Define an async function inside useEffect
        const fetchImages = async () => {
            try {
                const response = await getGalleryImages("GalleryPhoto");
            
                setImages(Array.isArray(response.data.images) ? response.data.images : []);
            } catch (error) {
                console.error("Error fetching images:", error);
            }
        };

        // Call the async function
        fetchImages();
    }, []); // Empty dependency array, so it only runs once when the component mounts

    const isTall = (index) => {
        // Define logic for "tall" images
        return [2, 5, 10, 11, 14, 15, 17, 19].includes(index);
    };

    const handleImageClick = (url) => {
        setSelectedImage(url);
    };

    const closeModal = () => {
        setSelectedImage(null);
    };

    return (
        <>
         <div className="gline"></div>
                <h2 className="text-orange-500 font-semibold text-2xl sm:text-3xl md:text-4xl relative -top-1 left-6 sm:left-14 md:left-20 lg:left-28 xl:left-0 mx-0 px-4" style={{marginTop:'2rem'}}>Events, Seminar and Workshop</h2>

            <div className="gallery-container-website">
                               <div className="gallery">
                    {images.map((image, index) => (
                        <div
                            className={`image-container ${isTall(index) ? "tall" : ""}`}
                            key={image.id}
                        >
                            <img
                                 src={`${"https://console.fbsedu.in/storage/app/"}/${image.image_path}`}
                                alt={`Random Image ${index + 1}`}
                                onClick={() => handleImageClick(image.url)}
                                className="photoos"
                            />
                         </div>
                    ))}
                </div>
            </div>

            {selectedImage && (
                <div className="modal" onClick={closeModal}>
                    <img
                        src={selectedImage}
                        alt="Selected"
                        className="modal-image"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </>
    );
};

export default CampusLife;
